import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import RemotelyActionable from "./remotelyActionable.ts";
const closedTileIndex = 0;
const openedTileIndex = 2;
/*
 * Door block the way if closed, and allow you to pass through if opened
 */
class RemoteDoor extends RemotelyActionable {
    constructor(pos) {
        super(pos, closedTileIndex);
        // Overridden by the child class to make the actionable interactive
        this.key = "KeyE";
        this.state = "closed";
        this.setCollision(true, true, false, true);
        this.mass = 0; // Not affected by gravity
        this.distance = 2;
    }
    action() {
        console.log("Action triggered on RemoteDoor");
        if (this.state == "closed") {
            this.state = "open";
            this.setCollision(false, false, false, false);
            this.tileInfo = LJS.tile(openedTileIndex, tilesize);
        }
        else {
            this.state = "closed";
            this.setCollision(true, true, false, true);
            this.tileInfo = LJS.tile(closedTileIndex, tilesize);
        }
    }
    // Displays a message when we are near the actionable
    message() {
        if (this.state === "closed") {
            LJS.drawTextOverlay("The door is closed, find the lever to activate it", LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
        }
        else {
            LJS.drawTextOverlay("The door is open", LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
        }
    }
}
export default RemoteDoor;
